import { LayoutPersonal } from '../../../../layouts/personal/index';
/*
 * @Author: your name
 * @Date: 2022-03-08 15:09:45
 * @LastEditTime: 2022-03-14 14:29:40
 * @LastEditors: Please set LastEditors
 * @Description: 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 * @FilePath: \pscd-portal-middle-office\packages\www\src\pages\personal\bindmobile\locales.ts
 */
export const EnumPageMeta: IEnumPageMeta = {
    /** 页面名称 */
    title: "账号解绑",
    login: true,
    layout: 'personal'
}
/**
 * 字段描述 枚举
 */
export enum EnumLocaleLabel {
}
export enum EnumGender {

}
export default {
    en: {
    },
    zh: {
    }
}